export default {
  'aiBilling.title': 'AI Billing',

  'aiBilling.tabs.profile': 'Perfil',
  'aiBilling.tabs.limits': 'Límites',
  'aiBilling.tabs.periods': 'Periodos',
  'aiBilling.tabs.grants': 'Créditos',

  'aiBilling.action.saveChanges': 'Guardar cambios',
  'aiBilling.action.save': 'Guardar',

  'aiBilling.validation.required': 'Este campo es obligatorio.',
  'aiBilling.validation.invalidEmails': 'Uno o más correos no tienen un formato válido.',
  'aiBilling.validation.negativeAmount': 'El monto no puede ser negativo.',

  'aiBilling.text.enabled': 'Activa',
  'aiBilling.text.disabled': 'Inactiva',
  'aiBilling.text.active': 'Activo',
  'aiBilling.text.inactive': 'Inactivo',

  'aiBilling.profile.billingMode': 'Modo de facturación',
  'aiBilling.profile.budgetEditMode': 'Modo de edición de presupuesto',
  'aiBilling.profile.currency': 'Moneda',
  'aiBilling.profile.isBudgetEnabled': 'Presupuesto habilitado',
  'aiBilling.profile.monthlyIncludedCreditOverrideAmount': 'Crédito incluido mensual personalizado',
  'aiBilling.profile.notifyMonthlyCreditGranted': 'Notificar crédito mensual otorgado',
  'aiBilling.profile.alertEmails': 'Correos de alerta',
  'aiBilling.profile.alertEmails.help': 'Separe múltiples correos con punto y coma (;).',
  'aiBilling.profile.monthlyBudgetAmount': 'Monto de presupuesto mensual',
  'aiBilling.profile.maxSelfServiceBudgetAmount': 'Monto máximo de presupuesto en autoservicio',
  'aiBilling.profile.budgetExceededBehavior': 'Comportamiento al exceder presupuesto',

  'aiBilling.billingMode.creditCard': 'Tarjeta de crédito',
  'aiBilling.billingMode.manualBilling': 'Facturación manual',

  'aiBilling.budgetEditMode.selfService': 'Autoservicio',
  'aiBilling.budgetEditMode.requiresAutomyApproval': 'Requiere aprobación de Automy',
  'aiBilling.budgetEditMode.automyOnly': 'Solo Automy',

  'aiBilling.budgetExceededBehavior.blockUsage': 'Bloquear uso',
  'aiBilling.budgetExceededBehavior.allowWithWarning': 'Permitir con advertencia',

  'aiBilling.currency.usd': 'USD',

  'aiBilling.limits.monthlyBudget': 'Presupuesto mensual',
  'aiBilling.limits.monthlyBudgetAmount': 'Monto de presupuesto mensual',
  'aiBilling.limits.alerts': 'Alertas',
  'aiBilling.limits.addAlert': 'Agregar alerta',
  'aiBilling.limits.editAlert': 'Editar alerta',
  'aiBilling.limits.sendToOrganizationOwners': 'Enviar a propietarios de la organización',
  'aiBilling.limits.budgetDisabled':
    'El presupuesto está deshabilitado en el perfil. Active el presupuesto para editar límites.',
  'aiBilling.limits.deleteConfirm.title': 'Eliminar alerta',
  'aiBilling.limits.deleteConfirm.content': '¿Desea eliminar esta alerta de consumo?',

  'aiBilling.limits.columns.threshold': 'Umbral',
  'aiBilling.limits.fields.thresholdPercentage': 'Umbral (%)',
  'aiBilling.limits.columns.emailSubjectPrefix': 'Prefijo del asunto',
  'aiBilling.limits.columns.emails': 'Correos',
  'aiBilling.limits.columns.enabled': 'Estado',

  'aiBilling.periods.filter.status': 'Filtrar por estado',
  'aiBilling.periods.columns.period': 'Periodo',
  'aiBilling.periods.columns.status': 'Estado',
  'aiBilling.periods.columns.budget': 'Consumo / presupuesto',
  'aiBilling.periods.columns.credit': 'Crédito consumido / otorgado',
  'aiBilling.periods.columns.billableAmount': 'Monto facturable',
  'aiBilling.periods.columns.periodStart': 'Inicio',
  'aiBilling.periods.columns.periodEnd': 'Fin',

  'aiBilling.period.status.active': 'Activo',
  'aiBilling.period.status.closed': 'Cerrado',
  'aiBilling.period.status.blocked': 'Bloqueado',

  'aiBilling.grants.columns.type': 'Tipo',
  'aiBilling.grants.columns.period': 'Periodo',
  'aiBilling.grants.columns.balance': 'Disponible / original',
  'aiBilling.grants.columns.originalAmount': 'Monto original',
  'aiBilling.grants.columns.remainingAmount': 'Monto disponible',
  'aiBilling.grants.columns.currency': 'Moneda',
  'aiBilling.grants.columns.validFrom': 'Válido desde',
  'aiBilling.grants.columns.expiresAt': 'Expira',
  'aiBilling.grants.columns.isActive': 'Estado',
  'aiBilling.grants.columns.reason': 'Motivo',
  'aiBilling.grants.columns.creator': 'Creador',
  'aiBilling.grants.columns.created': 'Creado',

  'aiBilling.grant.type.planIncludedMonthlyCredit': 'Incluido en plan',
  'aiBilling.grant.type.promotionalCredit': 'Promocional',
  'aiBilling.grant.type.manualBonus': 'Bono manual',
  'aiBilling.grant.type.supportCompensation': 'Compensación soporte',
  'aiBilling.grant.type.paidCredit': 'Recarga',
  'aiBilling.grant.type.adjustment': 'Ajuste',
};
